import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { SwissAppConfigModels } from "src/app/models/swissappconfig-models";
import { HelperService } from "src/app/services/helper.service";
import { UserAuthenticationService } from "../../services/user-authentication.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { tap } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class UploadImagesService {
    private webServiceConfig?: SwissAppConfigModels.WebServiceConfig;

    constructor(
        private http: HttpClient,
        private userAuthService: UserAuthenticationService,
        private helperService: HelperService,
    ) {
        this.helperService
            .getSwissWebServiceConfig$()
            .pipe(
                takeUntilDestroyed(),
                tap((config) => {
                    this.webServiceConfig = config;
                }),
            )
            .subscribe();
    }

    public async uploadBild(
        file: File | Blob,
        objectID: string,
        filename: string,
        description: string,
    ): Promise<{ objectID: string; fileName: string; status: number | undefined }> {
        if (!this.webServiceConfig) {
            throw Error("no config");
        }

        const url = this.webServiceConfig!?.tishUrl;
        const formData = new FormData();

        const headers = new HttpHeaders({
            Authorization: `${this.helperService.getSwissAuthorization(this.userAuthService.currentUserInfo)}`,
        });
        const params: HttpParams = new HttpParams().set("objectID", objectID).set("fileName", filename).set("description", description);

        const options = {
            headers,
            params,
        };

        formData.append("file", file, filename); // Der 1. Parameter 'file' muss übereinstimmen mit dem Parameter im Endpunkt

        return new Promise((resolve, reject) => {
            this.http.post(url + "/UploadFile", formData, options).subscribe({
                next: (res: any) => {
                    resolve({ objectID: objectID, fileName: filename, status: res.status });
                },
                error: () => {
                    reject(filename);
                },
            });
        });
    }
}
